"use client"

import { CreativeCommons } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CreativeCommonsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CreativeCommonsIcon = component(Icon)({ as: CreativeCommons })
